import Button from '@rio-cloud/rio-uikit/Button';
import { FormattedMessage, FormattedPlural } from 'react-intl';

import type { OrderWithSortableKey } from '#utils/orders.util.ts';

type OrderTableToolbarProps = {
    singleOrder?: boolean;
    onOpenTourDialog: () => void;
    selectedOrders: OrderWithSortableKey[];
};

const ButtonLabel = ({
    singleOrder,
    selectedOrders,
}: {
    selectedOrders: OrderWithSortableKey[];
    singleOrder?: boolean;
}) => {
    if (singleOrder) {
        return <FormattedMessage id='intl-msg:ordercom-cloud-frontend.orders.plan-orders-dialog.title.zero' />;
    }

    if (selectedOrders.length === 0) {
        return <FormattedMessage id='intl-msg:ordercom-cloud-frontend.orders.plan-orders-dialog.title.zero' />;
    }
    return (
        <FormattedPlural
            value={selectedOrders.length}
            one={<FormattedMessage id='intl-msg:ordercom-cloud-frontend.orders.plan-orders-dialog.title.one' />}
            other={
                <FormattedMessage
                    id={'intl-msg:ordercom-cloud-frontend.orders.plan-orders-dialog.title.other'}
                    values={{ number_of_orders: selectedOrders.length }}
                />
            }
        />
    );
};

export const PlanOrdersButton = ({ onOpenTourDialog, selectedOrders, singleOrder = false }: OrderTableToolbarProps) => {
    const isCreateToursDisabled = () => selectedOrders.length === 0 || selectedOrders.some(o => o.status !== 'open');
    const autoTrackingKey = singleOrder ? 'ordercom.orders.plan-tour.single' : 'ordercom.orders.plan-tour.bulk';

    return (
        <Button
            bsStyle={Button.PRIMARY}
            iconName={'stack'}
            autoTrackingKey={autoTrackingKey}
            disabled={isCreateToursDisabled()}
            data-testid='plan-orders-button'
            onClick={onOpenTourDialog}
        >
            <ButtonLabel singleOrder={singleOrder} selectedOrders={selectedOrders} />
        </Button>
    );
};
